import { Injectable } from '@angular/core';
import {HttpProvider} from "../../providers/http/http";
import {global} from "../../environments/global";

@Injectable()
export class SensitiveService {

  constructor(private http: HttpProvider) { }

  getMsgsList(scope, page, pagesize,client?){

    let params = {
      date_type: scope,
      // page 从1 开始
      page: page,
      pagesize: pagesize,
    };
    let url = '/sensitive/get_log_by_client_id';
    if(global.shangCengFlag){
      url = '/sensitive/get_log_sc';
      params['sub_client_id'] = client;
    }

    return this.http.hPost(url, params);
  }

  getSensitiveList(){
    return this.http.hPost('/sensitive/get_rule_list_by_client_id');
  }

  deleteSensitive(id){
    return this.http.hPost('/sensitive/delete', {rule_id: id});
  }


  editSensitive(sensitive){
    let params = JSON.parse(JSON.stringify(sensitive));
    params.chatroom_name_list = params.chatroom_list.map(chatroom => chatroom.chatroomname);
    params.chatroom_list = null;

    let url = '/sensitive/create';
    if(params['rule_id']){
      url = '/sensitive/modify';
    }

    if(global.shangCengFlag){
      if(params['rule_id']){
        url = '/sensitive/modify_sc';
      }
      else {
        url = '/sensitive/create_sc';
      }
    }
    return this.http.hPost(url, params);
  }

  getSubList(){
    return this.http.hPost('/employee/get_sub_list');
  }
}



// WEBPACK FOOTER //
// ./src/pages/sensitive/sensitive.service.ts